import React from 'react';
import classnames from 'classnames';
import LocalizedLink from 'components/LocalizedLink';
import { LocationDescriptor } from 'history';
import { useTrekker } from 'utils/analytics';

const CSS = require('./RoundedButton.less');

interface LocalizedLinkButtonProps {
  children: any;
  size?: 'S' | 'M' | 'L';
  className?: string;
  inverted?: boolean;
  pink?: boolean;
  onClick?: (event: any) => void;
  fullWidth?: boolean;
  invertedBorder?: boolean;
  to: LocationDescriptor;
  edgeRounding?: "slight" | "medium" | "full";
  [key: string]: any;
}

function LocalizedLinkButton ({ size = 'M', children, className, inverted, pink, invertedBorder, onClick, to, edgeRounding = "full", ...rest }: LocalizedLinkButtonProps) {
  const trekker = useTrekker();
  const classes = classnames(CSS.Button, CSS.Link, {
    [className]: className,
    [CSS.Inverted]: inverted,
    [CSS.InvertedBorder]: invertedBorder,
    [CSS.PinkButton]: pink,
    [CSS.Large]: size === 'L',
    [CSS.Small]: size === 'S',
    [CSS.EdgeRoundedSlight]: edgeRounding === "slight",
    [CSS.EdgeRoundedMedium]: edgeRounding === "medium",
  });
  const handleClick = (event: any) =>{
    trekker.event('click',{linkTo: to});
    onClick?.(event)
  }

  return (
    <LocalizedLink
      to={to}
      className={classes}
      onClick={handleClick}
      {...rest}
    >
      <span className={CSS.LinkChildren}>
        {children}
      </span>
    </LocalizedLink>
  );
}

export default LocalizedLinkButton;
